import { FC } from 'react';
import { useRenameItemButtonColumnView } from './hooks';
import { RenameItemButton } from './RenameItemButton';

export const RenameItemButtonColumnView: FC = () => {
  const onRenameSuccess = useRenameItemButtonColumnView();

  return <RenameItemButton onRenameSuccess={onRenameSuccess} />;
};
